import { gql } from "@apollo/client";

export const BATCH_HANDLE_DRIVER_MIS_SCAN_NOT_RETURNED = gql`
    mutation BatchHandleDriverMisScanNotReturned($parcels: [DriverMisScanParcelInput!]!) {
        batchHandleDriverMisScanNotReturned(parcels: $parcels)
    }
`;
